export default function ChatGPT_4() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">ChatGPT-4</h1>
    </div>
  );
}
